import React from 'react';
const { useState, useEffect, useMemo } = React;
import { adminCall } from '../diagnostic/shared.jsx';
import { DIAGNOSTIC_STATUSES, t } from '../../diagnosticConfig.js';
import { PageHeader, LoadingState, ErrorState, EmptyState } from '../ui/States.jsx';
import { openPrepared } from '../serviceStart/ServiceStartPanel.jsx';
import { setReturn, clearReturnTo } from './ReturnToList.jsx';

// Operaciones › Diagnósticos: every diagnostic of the central base (diagnostic-admin › listAll, the same administration
// as inside a company), to find one without entering its company first. Only what identifies it and its dates; opening
// one opens the existing module inside its company (nothing is copied), with a way back to this list. Read only.

const STATUS = Object.fromEntries(DIAGNOSTIC_STATUSES.map(s => [s.key, t(s.label)]));
const fmt = (v) => (v ? new Date(v).toLocaleDateString('es', { day: 'numeric', month: 'short', year: 'numeric' }) : '');

export function openDiagnosticFromList(d) {
  setReturn('Diagnósticos', { page: 'diagnostics' }, ['accounts']);
  openPrepared('diagnostic', { id: d.id, accountId: d.accountId });
}

export default function DiagnosticsList() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [q, setQ] = useState('');
  const [status, setStatus] = useState('');
  const [hideTests, setHideTests] = useState(false); // test diagnostics are shown to work with them, marked «prueba»
  const load = () => { setError(''); adminCall({ action: 'listAll' }).then(setData).catch(e => setError(e.message || 'No se pudieron leer los diagnósticos.')); };
  useEffect(() => { clearReturnTo('diagnostics'); load(); }, []);
  const shown = useMemo(() => {
    const words = q.trim().toLowerCase().split(/\s+/).filter(Boolean);
    return (data?.diagnostics || []).filter(d => (!hideTests || !d.isTest) && (!status || d.status === status)
      && words.every(w => `${d.name} ${d.accountName || ''}`.toLowerCase().includes(w)));
  }, [data, q, status, hideTests]);
  const testCount = (data?.diagnostics || []).filter(d => d.isTest).length;

  return (
    <div className="page-content" style={{ padding: 20, maxWidth: 1100 }}>
      <PageHeader area="Operaciones · Servicios" title="Diagnósticos" subtitle="Todos los diagnósticos, con su empresa. Cada uno se abre en el módulo de siempre, dentro de su empresa." />
      {error && <ErrorState message={`${error} No significa que no haya diagnósticos.`} onRetry={load} />}
      {!data && !error && <LoadingState />}
      {data && <>
        {!data.accountsRead && <div role="alert" style={{ fontSize: 12, color: 'var(--globant-warning)', margin: '0 0 8px' }}>No se pudieron leer los nombres de las empresas: se muestran como «empresa sin leer».</div>}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', margin: '0 0 10px' }}>
          <input className="input" style={{ flex: '1 1 240px', padding: '8px 10px', border: '1px solid var(--globant-border)', borderRadius: 8, fontSize: 16 }} placeholder="Buscar por diagnóstico o empresa…" value={q} onChange={e => setQ(e.target.value)} aria-label="Buscar diagnósticos" />
          <select value={status} onChange={e => setStatus(e.target.value)} aria-label="Estado" style={{ padding: '8px 10px', border: '1px solid var(--globant-border)', borderRadius: 8 }}>
            <option value="">Todos los estados</option>
            {DIAGNOSTIC_STATUSES.map(s => <option key={s.key} value={s.key}>{t(s.label)}</option>)}
          </select>
          {testCount > 0 && <label style={{ fontSize: 13, display: 'flex', gap: 6, alignItems: 'center' }}><input type="checkbox" checked={hideTests} onChange={e => setHideTests(e.target.checked)} /> Ocultar los de prueba ({testCount})</label>}
        </div>
        {!shown.length ? <EmptyState title={data.diagnostics.length ? 'Ningún diagnóstico coincide con esos filtros.' : 'Todavía no hay diagnósticos.'}>{data.diagnostics.length ? null : 'Se crean desde la ficha de una empresa (pestaña Diagnostic) o desde una propuesta aceptada.'}</EmptyState>
          : <div style={{ display: 'grid', gap: 6 }}>{shown.map(d => (
            <button key={d.id} type="button" className="card" onClick={() => openDiagnosticFromList(d)}
              style={{ textAlign: 'left', cursor: 'pointer', border: '1px solid var(--globant-border)', padding: '10px 12px', display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'baseline', width: '100%' }}>
              <span style={{ flex: '2 1 240px', minWidth: 0 }}><b style={{ fontSize: 14 }}>{d.name || 'Diagnóstico sin nombre'}</b>
                <span style={{ display: 'block', fontSize: 12, color: 'var(--globant-muted)' }}>{d.accountName === null ? 'Empresa sin leer' : d.accountName || 'Sin empresa vinculada'}{d.isTest ? ' · prueba' : ''}</span></span>
              <span className="badge" style={{ fontSize: 11 }}>{STATUS[d.status] || d.status}</span>
              <span style={{ flex: '1 1 200px', fontSize: 12, color: 'var(--globant-muted)' }}>
                {d.formsDueAt ? `Formularios hasta ${fmt(d.formsDueAt)}` : d.formsOpenAt ? `Formularios abiertos el ${fmt(d.formsOpenAt)}` : 'Formularios sin abrir'}{d.reportDeliveredAt ? ` · Informe entregado el ${fmt(d.reportDeliveredAt)}` : ''}
              </span>
            </button>
          ))}</div>}
      </>}
    </div>
  );
}
